import React from 'react';
import PropTypes from 'prop-types';

export default class SectionAccordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      class: 'section'
    };

    this.handleClick = this.handleClick.bind(this);
    this.handleFAQClick = this.handleFAQClick.bind(this);
  }

  handleFAQClick(event){
    const clickTarget = event.target;
    const id = clickTarget.id;

    // To check the click content has solutionLink
    if (id && clickTarget.name === 'solutionLink') {
      event.preventDefault();
      const target = clickTarget.target || '_blank';
      window.open(`/${this.props.country}/smarthelp/article/${id.toLowerCase()}`, target);
    }  
  }

  handleClick() {
    if (this.state.open) {
      this.setState({open: false, class: 'section'});
      const btnList = document.getElementsByClassName('faqbtn accordion-header');
      for(let i = 0;i<btnList.length;i++) {
        btnList[i].setAttribute('aria-expanded', false);
      }
    } else {
      this.setState({open: true, class: 'section open'});
      const btnList = document.getElementsByClassName('faqbtn accordion-header');
      for(let i = 0;i<btnList.length;i++) {
        btnList[i].setAttribute('aria-expanded', true);
      }
    }
  }
  render() {
    const title = this.props.title;
    return (
    <div className={this.state.class}>
      <div className="tooglebutton"/>
      <div className="accordion-head">
      <button
        data-pa-click={JSON.stringify({
          link: `SectionAccordion-button-FAQs`,
          event_name: "brc_FAQs_clicked"
        })}
        className=" faqbtn sectionhead accordion-header"
        aria-expanded="false"
        onClick={this.handleClick}
      >
        {title}
      </button></div>
      <div className="articlewrap">
        <div className="article" onClick={this.handleFAQClick}>
          {this.props.children}
        </div>
      </div>
    </div>);
  }
}

SectionAccordion.propTypes = {
  title: PropTypes.object,
  children: PropTypes.object,
  country: PropTypes.string
};
